export const NewsList = [
   {
    id:0,
    date: '2025.11.01',
    title: 'ミットスキルクラス追加！',
    text: 'ミットスキルクラスが追加されました！',
  },
   {
    id:1,
    date: '2025.11.01',
    title: 'レッスンスケジュール変更しました！',
    text: '土曜日のレッスンスケジュールが変更となりましたので、ご確認ください！',
  },
    {
    id:2,
    date: '2025.11.01',
    title: 'よくある質問追加しました！',
    text: 'よくある質問追加しました！',
  },
  {
    id:3,
    date: '2024.08.19',
    title: 'スタッフ紹介追加しました！',
    text: 'スタッフ紹介追加しました！',
  },
  {
    id: 4,
    date: '2024.07.17',
    title: 'デイタイムキャンペーンを追加しました！',
    text: 'デイタイムキャンペーンを追加しました！',
  },
  {
    id: 5,
    date: '2024.07.17',
    title: 'クラス紹介追加しました！',
    text: 'クラス紹介追加しました！',
  },
  {
    id: 6,
    date: '2024.07.17',
    title: 'レッスンスケジュール変更しました！',
    text: 'レッスンスケジュール変更しました！',
  },
  {
    id: 7,
    date: '2024.07.17',
    title: 'よくある質問追加しました！',
    text: 'よくある質問追加しました！',
  },
  {
    id: 8,
    date: '2023.10.01',
    title: 'マススパーリングクラスを追加しました！',
    text: '10/6(金)から毎週金曜日の20:00〜21:00に追加されます！',
  },
  {
    id: 9,
    date: '2023.05.31',
    title: 'ホームページをリニューアルしました。',
    text: 'ホームページを<br>リニューアルしました。',
  },
  {
    id: 10,
    date: '2023.03.20',
    title: 'ホームページを開設しました。',
    text: 'ホームページを<br>開設しました。',
  },
]
